import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { imgUrl } from '../../../common/utilities/ImgUrl';
import { classes, cssClass } from '../../../style';
import { IUserInfo } from '../../../ts/models/IUserInfo';
import { SiteUrlsProps } from '../../selectors/SiteUrlsSelectors';
import { CardViewStyles } from './CardViewStyles';

const cssPrefix = 'LensThumbnail';

const rootClass = cssClass(cssPrefix, 'root', {
  color: 'inherit',
  textDecoration: 'none',
  $nest: {
    '&:hover': {
      color: 'inherit',
      textDecoration: 'none',
    }
  }
});

const iconClass = cssClass(cssPrefix, 'icon', {
  // TODO: change thumbnail image for lens thumbnail
  backgroundImage: imgUrl('spaces_masthead_lens.svg')
});

export interface LensThumbnailProps extends SiteUrlsProps {
  readonly hoveredOrSelected: boolean;
  readonly navigateUrl: string;
  readonly owner: IUserInfo;
}

export class LensThumbnail extends React.Component<LensThumbnailProps> {

  public render() {
    const containerClass = this.props.hoveredOrSelected ? CardViewStyles.CustomThumbnailHover : CardViewStyles.CustomThumbnail;
    return (
      <a className={classes(containerClass, rootClass)}
         href={this.props.navigateUrl}>
        <div>
          <div className={CardViewStyles.CustomThumbnailTopContainer}>
            <div className={classes(CardViewStyles.CustomThumbnailImg, iconClass)} title={Messages.lens()} />
          </div>
        </div>
      </a>
    );
  }
}
